
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Examranklist.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from 'react-router-dom';
const isXIOrAbove = (standard) => {
  if (!standard) return false;
  const std = standard.toUpperCase().trim();
  return std.startsWith('XI') || std.startsWith('XII') || std.startsWith('UG') || std.startsWith('PG');
};
const Examranklist = () => {
  const location = useLocation();
  const { examid, examTitle,studentstd } = location.state || {};

  //  console.log(examid, examTitle)



    const [loading, setLoading] = useState(true);
  const [examDetails, setExamDetails] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [selectedExam, setSelectedExam] = useState(null);
  const [results, setResults] = useState([]);
  const [error, setError] = useState('');
  // const [studentstd, setStudentStd] = useState('');
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showFullImage, setShowFullImage] = useState(false);
  const [addPopup, setAddPopup] = useState(false);
  const [EditPopup, setEditPopup] = useState(false);
  const [selectedStudentForCertificate, setSelectedStudentForCertificate] = useState(null);
  const [certificateFile, setCertificateFile] = useState(null);
  const [certificatePrice, setCertificatePrice] = useState('');
  const [examdata, setexamdata] = useState(null);
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);
  
  const navi=useNavigate()

 useEffect(() => {
    const role = localStorage.getItem("userRole");
    if (role !== "supperadmin") {
      // alert("Access denied. You do not have permission to view this page.");
      navi("/"); // redirect to home or login page
    }
  }, [navi]);


  useEffect(() => {
    
    checkexist();
    handleExamClick(examid, examTitle)
  }, []); // ✅ Only run on first mount


const checkexist = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/questions/checkcertifacateexist`);
    setexamdata(response.data);
    console.log(response.data)
  } catch (error) {
    console.log(error);
  }
};

 

  const handleExamClick = async (examid, examTitle) => {
    try {
      setLoading(true);
      setResults([]);
      setError('');

      const onlinePromise = axios.get(`${process.env.REACT_APP_API}/questions/exam-results/${examid}`);
      let resultsData = [];
       console.log("onlinepromise",(await onlinePromise).data)
      if (examid === 1) {
        const [offlineRes, onlineRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API}/questions/offline-exam-results`),
          onlinePromise,
        ]);
        resultsData = [...offlineRes.data, ...onlineRes.data];
      } else {
        const onlineRes = await onlinePromise;
        resultsData = onlineRes.data;
      }
      // console.log('lalalalllla  ',studentstd)
      const filtered = resultsData.filter((r) =>
        isXIOrAbove(studentstd) ? isXIOrAbove(r.standard) : !isXIOrAbove(r.standard)
      );

      const sorted = filtered.sort((a, b) => b.total_correct - a.total_correct);

      setSelectedExam({ id: examid, title: examTitle });
      setResults(sorted);
      console.log("sorted",sorted)
    } catch (err) {
      console.error('Error fetching results:', err);
      setError('❌ Error fetching exam results.');
    } finally {
      setLoading(false);
    }
  };

  const closeExamModal = () => {
    setSelectedSection(null);
    setExamDetails(null);
  };

  const closeResultsModal = () => {
    setSelectedExam(null);
    setResults([]);
    setError('');
  };

  const handleView = async (id) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/questions/viewexamresult/${id}`);
      setSelectedStudent(response.data);
    } catch (error) {
      console.error('Error fetching student details:', error);
    }
  };

  const closeStudentModal = () => {
    setSelectedStudent(null);
  };

  const handleAddCertificateClick = (Id) => {
    setSelectedStudentForCertificate(Id);
    setAddPopup(true);
  };

    const handleEditCertificateClick = (Id) => {
    setSelectedStudentForCertificate(Id);
    setEditPopup(true);
  };


  const handleCertificateSubmit = async () => {
  if (!certificateFile && !certificatePrice) {
    alert("Please fill all fields.");
    return;
  }

  const formData = new FormData();
  formData.append("id", selectedStudentForCertificate || ""); // optional
  if (certificateFile) formData.append("certificate", certificateFile);
  if (certificatePrice) formData.append("amount", certificatePrice);

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API}/questions/Addexamcertificate`,
      formData
    );
    alert(res.data.message);
    if (res.data.success) {
      setAddPopup(false);
      setCertificateFile(null);
      setCertificatePrice("");
    }

        checkexist();
    handleExamClick(examid, examTitle)
  } catch (err) {
    console.error("Failed to add certificate:", err);
    alert("Something went wrong. Please try again.");
  }
};




const handleCertificateEditSubmit = async () => {
  const id = selectedStudentForCertificate || "";
  const formData = new FormData();

  formData.append("id", id);

  if (certificateFile) {
    formData.append("certificate", certificateFile);
  }

  if (certificatePrice) {
    formData.append("amount", certificatePrice);
  }

  if (!certificateFile && !certificatePrice) {
    alert("Please provide a new certificate or amount to update.");
    return;
  }

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API}/questions/Editexamcertificate/${id}`,
      formData
    );

    alert(res.data.message);

    if (res.data.success) {
      setEditPopup(false);
      setCertificateFile(null);
      setCertificatePrice("");
    }
  } catch (err) {
    console.error("Failed to update certificate:", err);
    alert("Something went wrong. Please try again.");
  }
};


  return (
        <div className="examrank-container">
      <h2 className="examrank-title">📊 Exam Rank List</h2>
{/* 
      {loading ? (
        <p className="loading-text">Loading...</p>
      ) : (
        <>
          <div className="examrank-section" onClick={() => handleSectionClick('V to X')}>
            <h4 className="examrank-header">V to X</h4>
          </div>
          <div className="examrank-section" onClick={() => handleSectionClick('XI to PG')}>
            <h4 className="examrank-header">XI to PG</h4>
          </div>
        </>
      )} */}

      {/* Exam List Modal */}
      {selectedSection && examDetails && (
        <div className="examrank-modal">
          <div className="examrank-modal-content" style={{ maxWidth: '500px' }}>
            <span className="examrank-modal-close" onClick={closeExamModal}>&times;</span>
            <h3 className="examrank-modal-header">{selectedSection} Exams</h3>

            {examDetails.length > 0 ? (
              <ul className="examrank-list">
                {examDetails.map((examtype, index) => (
                  <li
                    key={examtype.id}
                    className={index % 2 === 0 ? 'gold' : 'silver'}
                    onClick={() => handleExamClick(examtype.id, examtype.title)}
                  >
                    <strong>{index + 1}. {examtype.title}</strong>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No exams available.</p>
            )}
          </div>
        </div>
      )}

      {/* Exam Results Modal */}
      {selectedExam && (
        <div className="examrank-modal">
          <div className="examrank-modal-content">
            <span className="examrank-modal-close" onClick={closeResultsModal}>&times;</span>
            <h3 className="examrank-modal-header">Rank List: {selectedExam.title}</h3>

            {loading ? (
              <p>Loading results...</p>
            ) : error ? (
              <p className="error">{error}</p>
            ) : results.length > 0 ? (
              <div className="table-wrapper">
                <table className="examrank-table">
                  <thead>
                    <tr>
                      <th>Rank</th>
                      <th>Name</th>
                      <th>Father's Name</th>
                      <th>Standard</th>
                      <th>Total Correct</th>
                      <th>Total Questions</th>
                      <th>Time Taken</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
  {results.map((r, idx) => {
   const certificateExists = examdata.some(e => 
  e.student_id.replace(/\s+/g, '') === r.student_id.replace(/\s+/g, '')
);

if (!certificateExists) {
  console.log("Missing certificate for student_id:", r.student_id);
}


    return (
      <tr key={r.student_id || idx}>
        <td>{idx + 1}</td>
        <td>{r.name}</td>
        <td>{r.father_name || '-'}</td>
        <td>{r.standard}</td>
        <td>{r.total_correct}</td>
        <td>{r.total_questions}</td>
        <td>{r.total_time_taken || '-'}</td>
        <td>
          <button className="view-btn" onClick={() => handleView(r.id)}>
            <FontAwesomeIcon icon={faEye} />
          </button>

          {/* ✅ Only show Add Certificate button if student doesn't already have one */}
          {!certificateExists && (
            <button className="view-btn" onClick={() => handleAddCertificateClick(r.id)}>
              <FontAwesomeIcon icon={faPlus} />
            </button>
          )}
             {certificateExists && (
            <button className="view-btn" style={{backgroundColor:'brown'}} onClick={() => handleEditCertificateClick(r.id)}>
              <FontAwesomeIcon icon={faPen} />
            </button>
          )}
        </td>
      </tr>
    );
  })}
</tbody>

                </table>
              </div>
            ) : (
              <p>No results available.</p>
            )}
          </div>
        </div>
      )}

      {/* Student Detail Modal */}
      {selectedStudent && (
        <div className="examrank-modal">
          <div className="examrank-modal-content" style={{ maxWidth: '400px' }}>
            <span className="examrank-modal-close" onClick={closeStudentModal}>&times;</span>
            <h3 className="examrank-modal-header">Student Details</h3>
            <div className="student-details">
              <img
                src={`${process.env.REACT_APP_API}/uploads/${selectedStudent.photo_path}`}
                alt="Student"
                className="student-photo"
                onClick={() => setShowFullImage(true)}
              />
              <div className="form-group">
                <label>Name</label>
                <input type="text" value={selectedStudent.name} readOnly />
              </div>
              <div className="form-group">
                <label>Father's Name</label>
                <input type="text" value={selectedStudent.father_name} readOnly />
              </div>
              <div className="form-group">
                <label>User ID</label>
                <input type="text" value={selectedStudent.UserId} readOnly />
              </div>
              <div className="form-group">
                <label>Standard</label>
                <input type="text" value={selectedStudent.standard} readOnly />
              </div>
              <div className="form-group">
                <label>School</label>
                <textarea value={selectedStudent.school} readOnly rows={2}></textarea>
              </div>
              <div className="form-group">
                <label>Aadhar Number</label>
                <input type="text" value={selectedStudent.aadharNumber} readOnly />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Fullscreen Image Modal */}
      {showFullImage && selectedStudent?.photo_path && (
        <div className="fullscreen-image-modal">
          <button className="fullscreen-back-btn" onClick={() => setShowFullImage(false)}>← Back</button>
          <img
            src={`${process.env.REACT_APP_API}/uploads/${selectedStudent.photo_path}`}
            alt="Full Student"
            className="fullscreen-image"
          />
        </div>
      )}

      {/* Certificate Upload Modal */}
      {addPopup && (
        <div className="examrank-modal">
          <div className="examrank-modal-content" style={{ maxWidth: '400px' }}>
            <span className="examrank-modal-close" onClick={() => setAddPopup(false)}>&times;</span>
            <h3 className="examrank-modal-header">Add Certificate</h3>
            <div className="form-group">
              <label>Certificate (PDF)</label>
              <input
                type="file"
                accept="application/pdf"
                onChange={(e) => setCertificateFile(e.target.files[0])}
              />
            </div>
            <div className="form-group">
              <label>Price Amount</label>
              <input
                type="text"
                value={certificatePrice}
                onChange={(e) => setCertificatePrice(e.target.value)}
              />
            </div>
            <button onClick={handleCertificateSubmit}>Submit</button>
          </div>
        </div>
      )}



       {EditPopup&& (
        <div className="examrank-modal">
          <div className="examrank-modal-content" style={{ maxWidth: '400px' }}>
            <span className="examrank-modal-close" onClick={() => setEditPopup(false)}>&times;</span>
            <h3 className="examrank-modal-header">Add Certificate</h3>
            <div className="form-group">
              <label>Certificate (PDF)</label>
              <input
                type="file"
                accept="application/pdf"
                onChange={(e) => setCertificateFile(e.target.files[0])}
              />
            </div>
            <div className="form-group">
              <label>Price Amount</label>
              <input
                type="text"
                value={certificatePrice}
                onChange={(e) => setCertificatePrice(e.target.value)}
              />
            </div>
            <button onClick={handleCertificateEditSubmit}>Submit</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Examranklist;
